import { Link } from "react-router-dom";
import drAmyMark from "@/assets/dr-amy.svg";
import orthodonticsMark from "@/assets/orthodontics.svg";

const COLUMNS = [
  {
    heading: "Practice",
    links: [
      { label: "About Dr. Amy", to: "/dr-amy" },
      { label: "About Dr. Bilous", to: "/dr-bilous" },
      { label: "Services", to: "/#services" },
      { label: "Patient Info", to: "/#patient-info" },
      { label: "Contact", to: "/#contact" },
    ],
  },
  {
    heading: "Locations",
    links: [
      { label: "Fairfield", to: "/locations/fairfield" },
      { label: "Orange", to: "/locations/orange" },
    ],
  },
  {
    heading: "Policies",
    links: [
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "HIPAA Notice", to: "/hipaa-policy" },
      { label: "Accessibility", to: "/accessibility" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-cream-100 text-sage-800">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-16 lg:grid-cols-12 lg:gap-10 lg:px-8">
        <div className="lg:col-span-5">
          <Link
            to="/"
            className="inline-flex items-center gap-3"
            aria-label="Dr. Amy Orthodontics"
          >
            <img src={drAmyMark} alt="" className="h-10 w-auto" />
            <img
              src={orthodonticsMark}
              alt=""
              className="h-[9px] w-auto"
            />
          </Link>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-sage-700/90">
            Personalized, modern orthodontic care in Fairfield and Orange,
            Connecticut. Two locations, one warm welcome.
          </p>
          <div className="mt-6 flex flex-wrap gap-4 text-sm">
            <a
              href="tel:2032552677"
              className="rounded-full border border-sage-200 bg-cream-50 px-4 py-2 hover:border-sage-400"
            >
              Fairfield · 203-255-2677
            </a>
            <a
              href="tel:2037990600"
              className="rounded-full border border-sage-200 bg-cream-50 px-4 py-2 hover:border-sage-400"
            >
              Orange · 203-799-0600
            </a>
          </div>
        </div>

        <div className="grid gap-10 sm:grid-cols-3 lg:col-span-7">
          {COLUMNS.map((col) => (
            <div key={col.heading}>
              <h4 className="font-serif text-sm uppercase tracking-[0.18em] text-blush-500">
                {col.heading}
              </h4>
              <ul className="mt-4 space-y-2 text-sm">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sage-700/90 transition hover:text-blush-500"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-sage-100">
        <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-3 px-6 py-6 text-xs text-sage-700/80 sm:flex-row sm:items-center lg:px-8">
          <p>© {new Date().getFullYear()} Dr. Amy Orthodontics. All rights reserved.</p>
          <p>Welcoming new patients in Fairfield County, CT.</p>
        </div>
      </div>
    </footer>
  );
}
